import { jsx } from '@emotion/react/jsx-runtime';
import { useState, useRef, useLayoutEffect } from 'react';

/**
 * Hook that measures the size and position of the provided content. This allows you to measure the
 * size of the content before it is rendered, which is particularly useful for animations.
 *
 * @param content - The content to measure.
 * @param onMeasure - Callback triggered when the content has been measured.
 * @param dependencies - Dependency list to trigger a re-measure.
 */ function usePreMeasure(content, onMeasure, dependencies) {
    const [measuring, setMeasuring] = useState(true);
    const ref = useRef(null);
    useLayoutEffect(()=>{
        if (ref.current) {
            onMeasure(ref.current.getBoundingClientRect());
            setMeasuring(false);
        }
    }, dependencies);
    return [
        {
            measuring,
            setMeasuring
        },
        /*#__PURE__*/ jsx("div", {
            ref: ref,
            "aria-hidden": true,
            style: {
                visibility: 'hidden'
            },
            children: content
        })
    ];
}

export { usePreMeasure };
//# sourceMappingURL=use-pre-measure.js.map
